
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { BankStatusResponse } from "../../models/dtos";

export const bankStatusesApi = createApi({
  reducerPath: 'bankStatusesApi',
  baseQuery: baseAuthQuery('BankStatuses'),
  tagTypes: ['BankStatus'],
  endpoints: (builder) => ({
    getBankStatuses: builder.query<ApiResponse<BankStatusResponse[]>, void>({
      query: () => "",
      providesTags: ['BankStatus'],
    }),
    getBankStatusById: builder.query<ApiResponse<BankStatusResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['BankStatus'],
    }),
    updateBankStatus: builder.mutation<ApiResponse<BankStatusResponse>, Partial<BankStatusResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['BankStatus'],
    }),
    deleteBankStatus: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['BankStatus'],
    }),
  }),
});
